<template>
  <div class="" id="home_wrapper"> 
    <div id="home">
      <AppNavigation textColor='#fff' from='home' position='fixed'/>
      <!------------- HERO IMAGE SECTION -------->
      <div id="banner" class="d-flex flex-wrap align-content-center justify-content-center">
        <div class="container-fluid">
          <div class="row align-content-center m-0 p-0" >
           
            <div class="col-12 hero-text justify-content-center align-items-center">
              <div class="container">
                <div class="row justify-content-start">
                 <div class="" >
                    <h2 class="">
                      <span>Accelerated Virtual</span> <br>
                      <span>Resilent Integration</span> <br>
                      <span>for a Vibrant Africa</span>
                    </h2>
                    <a class="btn p-3 my-4 button" style="font-weight:bold" href="#signUp">GET STARTED</a>
                    </div>
                </div>
                <div class="row hero-logo ">
                  <div class="col-xs-2 col-sm-4 col-lg-3 ml-auto">
                    <img  class="img-fluid" src="../assets/images/auweblogo-en.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
   <!------------------ PROJECTS ------------------->
  <div id="projects">
    <div class="container-fluid">
      <div class="col-12">
        <div class="row justify-content-center ">
          <div class="col-lg-11 col-md-12  col-sm-12 project-text">
            <p>
                AVRIVA is the collective effort of Africa’s continental governance institutions and private sector
                actors. The Pan-African private sector and continental multi-stakeholder platforms, like the AU’s 
                strategic partner, AfroChampions,have mobilized their resources and capacities to assist individual 
                countries integrate into AVRIVA.
            </p>
            <p>
              They have pledged to make available physical premises, telecommunication equipment, computing devices,
               network access points, expertise, logistics, knowledge, data, financial support and a host of other 
               facilitatory mechanisms. Furthermore, the multinationals in this giant collective, in particular, are 
               committed to seeing every country in Africa, regardless of infrastructural level, successfully integrate
                into, deploy, and embed AVRIVA into their domestic-level economic integration operations so that the 
                benefits of AfCFTA do not pass any country by. They have gone further to offer their own facilities within 
                the various countries to redeem their pledge.
            </p>
            <p>
              The time has come for African governments and the continental public sector to match this energy and enthusiasm
              with equal determination and passion to see our collective ambition to make AfCFTA a success through.
            </p>
          </div>
          <div class="col-12 py-3">
            <div class="row justify-content-center">
              <div class="col-lg-11 col-sm-12 col-md-12">
                <h5 class="py-3">
                  African Virtual Resilience Initiative for Vital Integration (AVRIVA) will encompass four dimensions:
                </h5>
              </div>
              <div class="col-lg-11 col-sm-12 col-md-12">
                
                  <div class="row  flex-lg-row flex-md-row flex-sm-row project-card justify-content-around">
                    <div class=" ">
                        <p>An African Virtual Diplomacy Platform </p>
                    </div>
                    <div class="">
                      <p>Cybersecurity  </p>
                    </div>
                    <div class="">
                      <p>An African Cross-Border E-Trade Platform</p>
                    </div>
                    <div class="">
                      <p >Pan-African Biosecurity, Biosurveillance, & Bioscreening protocols and border crossings</p>
                    </div>
                  </div>
                
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!------------------ RESOURCE PARTNERS ---------------------->
  <div id="resource-partners">
    <div class="container-fluid">
      <div class="col-12">
         <div class="row justify-content-center resource_partners">
         <div class="col-lg-11 col-sm-12 col-md-12">
          <h2 class="">STRATEGIC PARTNER</h2>
        </div>
        <div class="col-lg-11 col-sm-12 col-md-12 pt-3 pb-5  strategic_partner">
            <img  src="../assets/images/partners/afrochampions.png" alt="">
        </div>
        <div class="col-lg-11 col-sm-12 col-md-12">
          <h2 class="pb-4">RESOURCE PARTNERS</h2>
        </div>
        <div class="col-lg-11 col-sm-12 col-md-12">
          <div class="row justify-content-between">
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/mtn.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/ecobank.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/fb_equity_bank_lg_logo.jpg" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/orascom-telecom.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/Sahara-group-logo.jpg" alt="">
            </div>
          </div>
        </div>

        <div class="col-lg-11 col-sm-12 col-md-12">
          <div class="row justify-content-between">
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/Afreximbank_Logo_Secondary_CMYK.jpg" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/tdb-new-logo.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/afc.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/cib.png" alt="">
            </div>
            <div class="col-2">
              <img class="img-fluid" src="../assets/images/partners/africa.jpg" alt="">
            </div>
          </div>
        </div>

      </div>
    </div>
      </div>
  </div>
  <!------------------ SIGN UP ---------------------->
  <div id="signUp">
    <div class="container signUp-inner mt-5">
      <h2>SIGN UP FOR REGULAR UPDATES</h2>
      <form>
          <div class="row justify-content-">
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Name">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="email" class="form-control" placeholder="Email">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Organization">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Telephone Number">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5 ml-auto">
              <button class="btn button">SEND</button>
            </div> 
          </div>
        </form>
    </div>
  </div>
 <!------------------------- FOOTER ------------------------>
<Footer />
</div>
</template>

<script>
import Footer from '../components/Footer'
import AppNavigation from '../components/AppNavigation'

export default {
  components: {
    Footer,
    AppNavigation
  },

  created(){
    
  }
}
</script>

<style scoped>
#home_wrapper{
  height: 100%;
  width:100%;
}
#home{
  /* position:sticky;
  top:0;
  z-index: 10; */
  background:rgb(25,22,51);
  background-image: url('../assets/images/hero-min.jpg');
  width:100%;
  height: 100%;
  /* overflow: hidden; */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#banner{
  height: calc(100% - 59px);
  padding-top:170px;
}

.side-image-right-container{
  position:absolute;
  bottom:10px;
  right:-19%;
} 
.hero-text h2{
  color:#fff;
  font-weight: 500;
  font-size: 3.7em;
}
.hero-text button{
  margin:1.5em;
  padding:10px;
}
.button{
  background-color: rgb(170,3,31);
  color:#fff;
}
.button:hover{
  background-color: rgb(129, 21, 39);
  color:#fee;
}
/*--------------------- ABOUT ------------------*/
.about-content{
  padding-top:100px;
  padding-bottom: 100px;
}
.about-content h2, #signUp h2{
  font-size:3em; 
  font-weight: 500; 
  color:#000;
}
 
/*--------------------- SIGN UP -----------------*/
#signUp{
  background-attachment: fixed;
  background:rgb(25,22,51);
  color:#fff;
  height: auto;
}
.signUp-inner{
  padding-top:100px;
  padding-bottom: 100px;
}
#signUp h2{
  color:#fff;
  font-size: 2em;
}
#signUp button {
  color:#fff;
  font-size:1.1em;
  padding:10px 20px;
}
::placeholder{
  color:#fff;
}
#signUp input{
  background-color: inherit;
  padding:20px !important;
  border:2px solid rgb(170,3,31);
  color:#fff;
}
/* input:focus{
  background-color:rgb(219, 213, 213) !important;
  color:rgb(170,3,31) !important;
  outline:0 !important;
}
::placeholder:focus{
  color:rgb(170,3,31) !important;
} */
/*------------------ PROJECTS ---------------------------*/
#projects {
  padding:80px 0px;
  color:rgb(25,22,51);
  background-color: #fff;
}
#projects p{
  font-size: 1em;
}
.project-text{
  text-align:justify;
}
.project-card div{
  color:rgb(170,3,31);
  background-color: rgb(25,22,51);
  border-radius: .5rem;
  display:flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width:20%;
  padding:20px 10px;
}
#resource-partners {
  margin-top: 50px;
  margin-bottom: 100px;
}
#resource-partners h2{
  font-size: 1.5rem;
}
.strategic_partner img{
  max-width:250px;
}
/**-------------------------- media queries ------------ */
@media screen and (max-width:490px) {
  .hero-text h2{
   font-size: 3em;
  }
  .project-card div{
   width:100% !important  ;
 }
}
@media screen and (max-width:576px)
{
  #banner{
    padding-top: 100px;
  }
  .strategic_partner img{
    width:130px;
  }
  .hero-logo img{
    width:100px !important;
    float:right !important;
  }
  .hero-text h2{
    font-size: 2.2em;
  }
}
@media screen and (max-width:767px){
 .project-card div{
   margin-top:30px;
   height: 150px;
   width:45%;
 } 

}
</style>